/**
 * Toast context – app-wide toasts (success, error, warning, info).
 * `ToastProvider` (ToastProvider.tsx) renders the container; `useToast` reads it.
 */

import {
  createContext,
  use,
} from 'react';

export interface ToastContextValue {
  success: (message: string, options?: { iconType?: import('@design-tokens/icons').IconType }) => void;
  error: (message: string, options?: { iconType?: import('@design-tokens/icons').IconType }) => void;
  warning: (message: string, options?: { iconType?: import('@design-tokens/icons').IconType }) => void;
  info: (message: string, options?: { iconType?: import('@design-tokens/icons').IconType }) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export function useToast(): ToastContextValue {
  const ctx = use(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
